const DB_NAME = 'flow_builder_drafts';
const DB_VERSION = 1;
const STORE_NAME = 'drafts';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'flowId' });
      }
    };
    request.onsuccess = (e) => resolve(e.target.result);
    request.onerror = (e) => reject(e.target.error);
  });
}

/**
 * Saves the flow definition to IndexedDB as a draft.
 * @param {string|number} flowId 
 * @param {object} definition 
 */
export async function saveDraftStore(flowId, definition) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const data = {
        flowId: String(flowId),
        definition,
        updatedAt: Date.now(),
      };
      const request = store.put(data);
      request.onsuccess = () => resolve();
      request.onerror = (e) => reject(e.target.error);
    });
  } catch (err) {
    console.error('Failed to save draft to IndexedDB:', err);
  }
}

/**
 * Loads the flow draft from IndexedDB.
 * @param {string|number} flowId 
 * @returns {Promise<{flowId: string, definition: object, updatedAt: number}|null>}
 */
export async function loadDraftStore(flowId) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(String(flowId));
      request.onsuccess = (e) => resolve(e.target.result || null);
      request.onerror = (e) => reject(e.target.error);
    });
  } catch (err) {
    console.error('Failed to load draft from IndexedDB:', err);
    return null;
  }
}

/**
 * Clears the draft for the given flow ID from IndexedDB.
 * @param {string|number} flowId 
 */
export async function clearDraftStore(flowId) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete(String(flowId));
      request.onsuccess = () => resolve();
      request.onerror = (e) => reject(e.target.error);
    });
  } catch (err) {
    console.error('Failed to clear draft from IndexedDB:', err);
  }
}
